module.exports = __webpack_public_path__ + "static/media/gf.2ab15edf.svg";